import { render } from "./BookingsPageRouter.vue?vue&type=template&id=7b7a22c5"
import script from "./BookingsPageRouter.vue?vue&type=script&lang=js"
export * from "./BookingsPageRouter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__